export const questionsAndAnswers = [
    {
        "id": 1,
        "Q": "Why haven't we been paid for this order?",
        "A": "You will see payment approximately 21 business days after the COC submitted was approved by our Customer Service team."
    },
    {
        "id": 2,
        "Q": "Could I get an updated Color Crossover List",
        "A": "Updated Crossover Lists are posted in the Document Library tab of your portal. They are also sent out in CFI Communication email. If unable to find, your Support Specialist can provide this to you."
    },
    {
        "id": 3,
        "Q": "I completed a Measure and now the order is cancelled. How do I get paid for this?",
        "A": "Email our Sales team at sales@sagesurfaces.com for assistance."
    },
    {
        "id": 4,
        "Q": "Why can't I see this order in my portal?",
        "A": "If an order is on hold for Pricing Validation, it will not be visible in your portal. These are handled daily and once resolved, will appear in Sage Sync."
    },
    {
        "id": 5,
        "IMEOnly": true,
        "Q": "Why can't I 'confirm' an order in Sage Sync if there aren't any changes needed?",
        "A": "The 'Confirm' button is missing for IME orders. A Change Order is required for every IME job, as the customer must sign this as per their contract. You can submit a Change Order without any changes."
    },
    {
        "id": 6,
        "IMEOnly": true,
        "Q": "The customer has signed the Change Order for this IME job, but the status still shows Hold.",
        "A": "Our IME team will verify that the Change Order sent from IME reflects the one submitted by you. These are handled daily, and you will receive an emailed note stating the hold is released and you may proceed with the order. In these cases, please do not request 'CFI Assistance' in your portal, as this will result in the order remaining in the Hold status."
    },
    {
        "id": 7,
        "Q": "Where can I find how much I will be paid for an item?",
        "A": "These are available in the Payment Schedule tab of your portal. If needed, your Regional Sales Manager will be able to provide these."
    },
    {
        "id": 8,
        "Q": "I am trying to submit a Change Order and cannot add certain SKU's.",
        "A": "This is likely because you are changing product lines. You will need to change the 'Product Type' to the one you need, and the correct SKU's will be available. If you are still having issues, please reach out to your Support Specialist."
    },
    {
        "id": 9,
        "Q": "This customer's add-on PO is in the portal. Why is the original order still on Hold?",
        "A": "If all the customer's orders total the amount requested on your Change Order, you will need to 'cancel' your change request in Sage Sync and then click 'confirm' to release the hold and proceed."
    },
    {
        "id": 10,
        "Q": "How do I know what the materials I order will cost?",
        "A": "This can be found in the Material Cost tab of your portal under \"Supporting Elements\""
    },
    {
        "id": 11,
        "Q": "Why am I no longer receiving portal notification emails?",
        "A": "Please contact customer support to re-subscribe to email notifications. Once completed, we will send a test email to ensure you are successfully receiving these again."
    }

]